import React, { useState } from 'react';
import Modal from './Modal';
import Input from './Input';
import Button from './Button';
import UsuariosServiceAPI from '../../services/usuariosServiceAPI';

// Mesma regra do backend (usuarios.js validarForcaSenha)
const REGRAS_SENHA = [
  { label: 'Mínimo de 8 caracteres', test: (s: string) => s.length >= 8 },
  { label: 'Letra maiúscula', test: (s: string) => /[A-Z]/.test(s) },
  { label: 'Letra minúscula', test: (s: string) => /[a-z]/.test(s) },
  { label: 'Número', test: (s: string) => /[0-9]/.test(s) },
  { label: 'Caractere especial (!@#$%...)', test: (s: string) => /[!@#$%^&*(),.?":{}|<>]/.test(s) }
];

interface AlterarSenhaModalProps {
  isOpen: boolean;
  onClose: () => void;
  usuarioId: string;
  usuarioNome: string;
}

const AlterarSenhaModal: React.FC<AlterarSenhaModalProps> = ({
  isOpen,
  onClose,
  usuarioId,
  usuarioNome
}) => {
  const [formData, setFormData] = useState({
    novaSenha: '',
    confirmarNovaSenha: ''
  });
  const [loading, setLoading] = useState(false);

  const senhaValida = REGRAS_SENHA.every(r => r.test(formData.novaSenha));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!usuarioId) {
      alert('Usuário não identificado.');
      return;
    }

    if (formData.novaSenha !== formData.confirmarNovaSenha) {
      alert('A nova senha e a confirmação não coincidem!');
      return;
    }

    if (!senhaValida) {
      alert('A nova senha não atende todos os requisitos abaixo.');
      return;
    }

    try {
      setLoading(true);
      await UsuariosServiceAPI.atualizar(usuarioId, { senha: formData.novaSenha, primeiro_acesso: false });

      alert('Senha alterada com sucesso!');
      setFormData({ novaSenha: '', confirmarNovaSenha: '' });
      onClose();
    } catch (error: any) {
      console.error('Erro ao alterar senha:', error);
      const msg = error?.response?.data?.details?.[0]?.msg || error?.response?.data?.error || 'Erro ao alterar senha';
      alert(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Alterar Senha - ${usuarioNome}`} size="md">
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          label="Nova Senha"
          type="password"
          value={formData.novaSenha}
          onChange={(value) => setFormData({ ...formData, novaSenha: value })}
          required
        />
        <Input
          label="Confirmar Nova Senha"
          type="password"
          value={formData.confirmarNovaSenha}
          onChange={(value) => setFormData({ ...formData, confirmarNovaSenha: value })}
          required
        />

        {/* Checklist de requisitos da senha */}
        <div className="bg-gray-50 border border-gray-200 rounded-md p-3">
          <p className="text-xs font-semibold text-gray-600 mb-2">A senha precisa ter:</p>
          <ul className="space-y-1">
            {REGRAS_SENHA.map(regra => {
              const ok = regra.test(formData.novaSenha);
              return (
                <li key={regra.label} className={`text-xs flex items-center gap-2 ${ok ? 'text-green-600' : 'text-gray-400'}`}>
                  <span>{ok ? '✓' : '○'}</span>
                  {regra.label}
                </li>
              );
            })}
          </ul>
        </div>

        <div className="flex justify-end gap-3 pt-4">
          <Button variant="outline" onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button type="submit" loading={loading} disabled={loading}>
            Alterar Senha
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default AlterarSenhaModal;
